import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import moment from "moment";
import log from '../../../helpers/logger'
import { auth, getCurrentUser } from '../../../helpers/auth'
import { getTimeStamp, getUUIDV4 } from '../../../helpers/utils'
import {
  createD2hPublishMagazine,
  updateD2hPublishMagazine,
  deleteD2hPublishMagazine,
  getD2hPublishMagazine,
  getD2hPublishMagazineListNotDeleted,
  getD2hPublishMagazineList } from '../../../services/D2hPublishMagazineService'

function setErrorMsg(error) {
  return {
    errorMsg: error.message
  }
}

export default class D2hPublishMagazinePageList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      errorMsg: null,
      currentUser: null,
      isLoading: true,
      dataList: []
    };

  }

  componentWillMount() {
    log.debug('componentWillMount')
  }
  async componentDidMount(){
    log.debug('componentDidMount')
    let user = await getCurrentUser();
    this.setState({currentUser: user})

    let dataList = await getD2hPublishMagazineListNotDeleted();
    /*
    log.debug(dataList.length)
    dataList.forEach(function(doc) {
        log.debug(doc.id, " => ", doc.data());
    });
    */

    log.debug('all data is loaded.')
    this.setState({dataList: dataList})
    this.setState({isLoading: false})
  }

  render () {

    let content;

    if (this.state.isLoading) {
      content = <div>Loading...</div>;
    } else {
      content =
      <div>
          <h4 className="page-header">
          <Link to='/d2hpublishmagazine'>D2hPublishMagazine</Link> ->
          List
        </h4>
          <table className="table">
              <thead>
                  <tr>
                      {/* <th> d2hpublishmagazine_id </th>

                      <th>issue_id</th>
                      <th>issue_uuid</th>
                      <th>magazine_id</th>
                      <th>magazine_uuid</th> */}
                      <th>title</th>
                      {/* <th>description</th>
                      <th>book_download_url</th>
                      <th>download_success_msg_body</th> */}
                      <th>download_success_msg_title</th>
                      {/* <th>notify_cover_number</th> */}
                      <th>notify_when</th>
                      <th>date_created</th>
                      <th>status</th>
                      <th> Actions </th>
                  </tr>
              </thead>
              <tbody>
                {
                  this.state.dataList.map((data, index) =>
                  <tr key={index}>
                    {/* <td>{data.id}</td>

                      <td>{data.data().issue_id} </td>
                      <td>{data.data().issue_uuid} </td>
                      <td>{data.data().magazine_id} </td>
                      <td>{data.data().magazine_uuid} </td> */}
                      <td>{data.data().title} </td>
                      {/* <td>{data.data().description} </td>
                      <td>{data.data().book_download_url} </td>
                      <td>{data.data().download_success_msg_body} </td> */}
                      <td>{data.data().download_success_msg_title} </td>
                      {/* <td>{data.data().notify_cover_number} </td> */}
                      <td>{data.data().notify_when} </td>
                      {/* <td>{data.data().date_created} </td>  */}
                      <td>{moment(data.data().date_created).fromNow()}</td>
                      <td>{data.data().status} </td>
                    {/* <td>{moment(data.data().date_created).fromNow()}</td> */}
                    <td>
                      <Link className="btn btn-small btn-primary" to={`/d2hpublishmagazine/view/${data.id}`}>view</Link>
                    </td>
                  </tr>
                )
                }
              </tbody>
          </table>
          <p>
              <Link className="btn btn-success" to='/d2hpublishmagazine/add'>Add New D2hPublishMagazine</Link>
          </p>
      </div>
    }


    return (
      <div>
          {content}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/D2hPublishMagazinePage/D2hPublishMagazinePageList.js